<template>
  <div class="c-table" ref="monitortable">
    <el-table
      class="common-el-table-styles"
      :data="data"
      :height="height"
      v-loading="loading"
      border
      stripe
      @selection-change="changeSelection"
    >
      <el-table-column type="selection" width="47" :selectable="rowSelectable"></el-table-column>
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
      >
        <template slot-scope="scope">
          <div v-if="col.key === 'state'">
            <Poptip confirm transfer :title="popTitleTxt(scope.row.status)" @on-ok="switchPlan(scope.row)">
              <i class="cover-mask"></i>
              <i-Switch :value="scope.row.status" size="small" :true-value="0" :false-value="1" />
            </Poptip>
          </div>
          <div v-else-if="col.key === 'gameInfo'">
            <p v-for="(info, i) in scope.row.gameList" :key="i">{{ info }}</p>
          </div>
          <div v-else-if="col.key === 'monitorConditionDesc'">
            <span class="block-span g-error-text" v-if="![6, 7].includes(scope.row['ruleType'])">
              {{ scope.row['dataRange'] | dataRangeType }}
            </span>
            <span class="block-span" v-for="(cond, i) in scope.row[col.key]" :key="i">{{ cond }}</span>
          </div>
          <div v-else-if="col.key === 'planCount'">
            <el-button v-if="scope.row.rangeType === 1" type="text" @click.prevent="getPlanIds(scope.row)">
              {{ scope.row[col.key] }}
            </el-button>
            <span v-else>-</span>
          </div>
          <div v-else-if="col.key === 'accountCount'">
            <el-button v-if="scope.row.rangeType === 1" type="text" @click.prevent="getPlanIds(scope.row)">
              {{ scope.row[col.key] }}
            </el-button>
            <span v-else>-</span>
          </div>
          <div v-else-if="col.key === 'control'">
            <el-button type="text" size="small" @click="editClick(scope.row)">修改规则</el-button>
            <el-button type="text" size="small" @click="copyClick(scope.row)" class="c-control-margin">复制</el-button>
            <Poptip confirm transfer title="您确认删除该自动规则吗？" @on-ok="delClick(scope.row)">
              <el-button type="text" size="small">删除</el-button>
            </Poptip>
          </div>
          <span v-else-if="col.key === 'monitorTime'">{{ scope.row[col.key] | timeType }}</span>
          <span v-else-if="col.key === 'ruleType'">{{ scope.row[col.key] | ruleType }}<br />{{ scope.row['ruleTypeInfoDesc'] }}</span>
          <span v-else-if="col.key === 'updateTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
          <span v-else-if="col.key === 'lastTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>

    <select-modal
      v-model="model"
      :data="accounData"
      :include-data="includeData"
      :exclude-data="excludeData"
      :asyning="saving"
      :loading="preload"
      :media="media"
      :plan-ids="planIds"
      :exclude-plan-ids="excludePlanIds"
      :lock-len="lockLen"
      :plan-len="planLen"
      :exclude-plan-len="excludePlanLen"
      :sub-media="subMediaId"
      @on-select="selectAll"
      @on-change="uploadPlanIds"
    />
  </div>
</template>
<script>
import { isArray, getIdOfData, timeout, findCheckChild, deepCopy } from '@/common/js/utils'
import { adAccount } from '@/api/common.model'
import { switchPlanAutoRuleStatus, getAdTreeList, getAdListByRuleId, uploadAdListByRuleId, delAutoRule } from '@/api/manage.model'
import SelectModal from './selecter/select-modal'
export default {
  name: 'monitorTable',
  components: {
    SelectModal
  },
  props: {
    value: {
      type: Array
    },
    data: {
      type: Array,
      default() {
        return []
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    columns: {
      type: Array
    },
    height: {
      type: Number
    }
  },
  computed: {
    selection: {
      get() {
        return this.value || []
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    rowSelectable() {
      return (row) => {
        if (this.selection.length) {
          const { mediaId } = deepCopy(this.selection).pop()
          return row.mediaId === mediaId
        } else return true
      }
    },
    lockLen() {
      return this.accounData.filter((ret) => ret.check).length
    },
    planLen() {
      return findCheckChild(this.includeData).filter((ret) => ret.plan).length
    },
    excludePlanLen() {
      return findCheckChild(this.excludeData).filter((ret) => ret.plan).length
    }
  },
  methods: {
    popTitleTxt(state) {
      const txt = state ? '开启' : '关闭'
      return `确定要${txt}此规则吗？`
    },
    switchPlan(row) {
      const { id, status } = row
      const changStat = status ? 0 : 1
      switchPlanAutoRuleStatus({
        ruleIds: [id],
        status: changStat
      }).then((data) => {
        if (data) {
          this.$set(row, 'status', changStat)
          this.$emit('on-refresh')
        }
      })
    },
    changeSelection(selection) {
      this.$emit('input', selection)
    },
    editClick(row) {
      const { id } = row
      const query = { id, t: 'edit' }
      this.$router.push({ name: 'monitoredit', query })
    },
    copyClick(row) {
      const { id } = row
      this.$router.push({ name: 'monitoradd', query: { id } })
    },
    delClick(row) {
      const { id } = row
      delAutoRule({ ruleId: id }).then((data) => {
        if (data) this.$emit('on-refresh')
      })
    },
    // 全选
    selectAll({ list, check = true, current = '' }) {
      let data
      // 无限递归
      const setAllChecked = (data, check) => {
        data.forEach((ret) => {
          if (ret.children && ret.children.length) setAllChecked(ret.children, check)
          this.$set(ret, 'check', check)
        })
      }
      if (current) {
        const item = getIdOfData(list, current)
        data = item.children
      } else data = list
      setAllChecked(data, check)
    },
    getPlanIds(row) {
      const { mediaId, id } = row
      this.media = mediaId // 账号选择组件需要
      this.preload = true
      this.model = true // 显示弹窗
      getAdListByRuleId({ ruleId: id }).then((data) => {
        if (data) {
          const { accountIds, accounts, planIds, excludePlanIds } = data
          // 账号处理
          this.accountIds = accountIds
          this.accounts = accounts
          this.planIds = planIds
          this.excludePlanIds = excludePlanIds
          this.ruleId = id
          this.subMediaId = row.subMediaId
          this.proloadData(mediaId, row.subMediaId)
        }
      })
    },
    proloadData(mediaId, subMediaId) {
      console.log(subMediaId)
      const accounts = this.accounts.map((ret) => {
        return getAdTreeList({ mediaId, adAccountId: ret, subMediaId })
      })

      Promise.all([adAccount({ mediaId, authFlag: 1 }), ...accounts])
        .then((data) => {
          const [accounData, ...preAccountData] = data
          // 有数据的账号要先查出来
          const preAccountList = preAccountData.reduce((pre, account) => {
            pre.push(account.pop())
            return pre
          }, [])
          if (isArray(accounData)) {
            this.accounData = accounData.map((ret) => {
              const check = isArray(this.accountIds) && this.accountIds.includes(ret.id)
              return { id: ret.id, name: ret.name, value: ret.name, check, children: [] }
            })
            this.includeData = accounData.map((ret) => this.parseAccountData(ret, deepCopy(preAccountList), this.planIds))
            this.excludeData = accounData.map((ret) => this.parseAccountData(ret, deepCopy(preAccountList), this.excludePlanIds))
          }
          this.preload = false
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    parseAccountData(ret, preAccountList, planIds) {
      const account = { id: ret.id, name: ret.name, children: [], xhr: false }
      // 修改|复制 处理计划选中
      if (isArray(this.accounts) && this.accounts.includes(ret.id)) {
        const { adGroupList } = preAccountList.filter((met) => met.id === ret.id).pop()
        Object.assign(account, {
          children: adGroupList.map((meta) => {
            return {
              id: meta.adGroup.id,
              name: meta.adGroup.name,
              children: meta.adPlanList.map((t) => {
                t.plan = true
                t.check = isArray(planIds) && planIds.includes(t.id)
                return t
              })
            }
          }),
          xhr: true
        })
      }
      return account
    },
    uploadPlanIds() {
      const accouts = this.accounData.filter((ret) => ret.check).map((ret) => ret.id)
      const include = findCheckChild(this.includeData)
        .filter((ret) => ret.plan)
        .map((ret) => ret.id)
      const exclude = findCheckChild(this.excludeData)
        .filter((ret) => ret.plan)
        .map((ret) => ret.id)

      this.saving = true
      uploadAdListByRuleId({
        ruleId: this.ruleId,
        lockAcountIds: accouts,
        planIds: include,
        excludePlanIds: exclude
      })
        .then((data) => {
          this.saving = false
          if (data) {
            this.model = false
            this.$Message.success({
              closable: true,
              duration: 2,
              content: '更新成功！'
            })
            timeout(2000).then(() => {
              this.$emit('on-refresh')
            })
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    }
  },
  filters: {
    ruleType(val) {
      let type
      switch (val) {
        case 1:
          type = '暂停计划'
          break
        case 2:
          type = '启用计划'
          break
        case 3:
          type = '更改预算'
          break
        case 4:
          type = '更改出价'
          break
        case 5:
          type = '仅消息提醒'
          break
        case 6:
          type = '智能模型'
          break
        case 7:
          type = '智能模型2'
          break
        case 8:
          type = '删除计划'
          break
        case 9:
          type = '复制计划'
          break
        case 10:
          type = '智能模型3'
          break
        case 11:
          type = '暂停素材'
          break
        case 12:
          type = '启用素材'
          break
        default:
          type = '未知'
          break
      }
      return type
    },
    timeType(val) {
      let timeTxt = ''
      const monitorTime = typeof val === 'string' && JSON.parse(val)
      if (monitorTime && monitorTime.key === 'half') timeTxt = '每半个小时'
      else if (monitorTime && monitorTime.key === 'fiveMin') timeTxt = '每5分钟'
      else if (monitorTime && monitorTime.key === 'quarter') timeTxt = '每15分钟'
      else if (monitorTime && monitorTime.key === 'day') timeTxt = `每天 ${monitorTime.value}`
      return timeTxt
    },
    dataRangeType(val) {
      let range = ''
      if (val === 1) range = '今日实时'
      else if (val === 2) range = '近2天（含今日）'
      else if (val === 3) range = '近3天（含今日）'
      else if (val === 5) range = '近5天（含今日）'
      else if (val === 7) range = '近7天（含今日）'
      return `${range}数据：`
    }
  },
  data() {
    return {
      saving: null,
      subMediaId: 1,
      preload: null, // 加载账号
      model: null,
      accounData: [],
      includeData: [],
      excludeData: [],
      accountIds: [],
      accounts: [],
      planIds: [],
      excludePlanIds: [],
      media: null
    }
  }
}
</script>
<style lang="scss" scoped>
.c-table {
  .block-span {
    display: block;
  }

  .c-control-margin {
    margin: 0;
    padding: 0 3px;
  }

  .ivu-poptip {
    position: relative;

    .cover-mask {
      display: inline-block;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      z-index: 3;
      cursor: pointer;
    }
  }
}
</style>
